import { createNamespace } from '../../utils';

var _createNamespace = createNamespace('table-indicator'),
    createComponent = _createNamespace[0],
    bem = _createNamespace[1]; // @ts-ignore


function TableIndicator(h, props) {
  var length = props.length,
      _props$value = props.value,
      value = _props$value === void 0 ? [] : _props$value;

  var Items = function Items() {
    return Array(length).fill(0).map(function (_theValue, index) {
      return h("div", {
        "key": index,
        "class": bem('item', [{
          active: value.includes(index)
        }])
      });
    });
  };

  return h("div", {
    "class": bem()
  }, [Items()]);
}

export default createComponent(TableIndicator);